import { Injectable } from '@angular/core';
    // import * as crypto from 'crypto-js';
    import * as CryptoJS from 'crypto-js';

    @Injectable()
    export class CryptoService {

    constructor() {
    }


//    encrypt(key: any) {
//      const cryptkey = crypto.enc.Utf8.parse(this.getCookie("con_adopt"));
//      const encrypted = crypto.AES.encrypt(key, cryptkey, {
//       iv: crypto.enc.Hex.parse('00000000000000000000000000000000'),
//       mode: crypto.mode.ECB,
//       padding: crypto.pad.Pkcs7
//    });
//    return encrypted.toString();
//   }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }


//   decrypt(cryptedKey: any) {
//       console.log("cryptedKey",cryptedKey);
//     const cryptoPrivateKey = crypto.enc.Utf8.parse(this.getCookie("con_adopt"));
//     const encryptedKey = crypto.enc.Base64.parse(cryptedKey);
//     const decrypted = crypto.AES.decrypt({ciphertext: encryptedKey}, cryptoPrivateKey, {
//       iv: crypto.enc.Hex.parse('00000000000000000000000000000000'),
//       mode: crypto.mode.ECB,
//       padding: crypto.pad.Pkcs7
//    });
//    console.log("decrypted",decrypted);
//    return decrypted.toString(crypto.enc.Utf8);
//   }

  encryptData(data) {

    try {
      return CryptoJS.AES.encrypt(JSON.stringify(data), this.getCookie("con_adopt")).toString();
    } catch (e) {
      console.log(e);
    }
  }

  decryptData(data) {

    try {
      const bytes = CryptoJS.AES.decrypt(data, this.getCookie("con_adopt"));
      if (bytes.toString()) {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      }
      return data;
    } catch (e) {
      console.log(e);
    }
  }
  
}